"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusFieldValueGetter = void 0;
const safe_field_value_1 = require("../safe-field-value");
const get_value_1 = require("./get-value");
const dates_1 = require("../type-checking/dates");
const objects_1 = require("../type-checking/objects");
const primitives_1 = require("../type-checking/primitives");
const typing_1 = require("../type-checking/typing");
const get_field_value_1 = require("../helpers/get-field-value");
class StatusFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.getFieldValue = (field, record) => {
            const fieldValue = (0, get_field_value_1.getValueFromRecordBySlug)(record, field);
            if (fieldValue === undefined)
                return this.getEmptyValue();
            if (this.isOptimizedFieldValue(fieldValue))
                return this.getValueFromOptimized(fieldValue);
            if (!this.isValidFieldValue(fieldValue))
                return this.getEmptyValue();
            return (0, get_value_1.generateStatusFieldValue)({ ...fieldValue });
        };
        this.isValidFieldValue = (fieldValue) => {
            return (0, objects_1.isValidObjectValue)(fieldValue, {
                value: primitives_1.isStringValue,
                updated_on: (0, typing_1.Optional)(dates_1.isNullableDateAsStringValue),
            });
        };
        this.getEmptyValue = () => (0, get_value_1.getStatusFieldEmptyValue)();
        this.isOptimizedFieldValue = (fieldValue) => {
            return (0, primitives_1.isStringValue)(fieldValue);
        };
        this.getValueFromOptimized = (fieldValue) => {
            return (0, get_value_1.generateStatusFieldValue)({ value: fieldValue });
        };
    }
}
exports.StatusFieldValueGetter = StatusFieldValueGetter;
